import { ACTIVITY_ACTION, ActivityContextType } from '..';
import verifyPythonPlaygroundQuestionCorrectness from '../helpers/verify-python-playground-question-correctness';
import updateQuestion from '../helpers/update-question';

export type SetResultPythonPlaygroundQuestionActionType = {
  type: typeof ACTIVITY_ACTION.SET_RESULT_PYTHON_PLAYGROUND_QUESTION;
  payload: {
    question: ActivityContextType['exercise']['questions'][0];
    result: string;
    shouldVerifyResult?: boolean;
  };
};
export function pythonPlaygroundResultChangeReducer(
  state: ActivityContextType,
  action: SetResultPythonPlaygroundQuestionActionType
) {
  const { question, result, shouldVerifyResult } = action.payload;

  const answer = {
    ...state.submission.questionSlugToAnswer[question.slug],
    result,
  };

  if (!shouldVerifyResult) {
    return updateQuestion({
      activity: state,
      question,
      answerPart: {
        ...answer,
        isRan: true,
        isCorrect: null,
      },
    });
  }

  const verificationResult = verifyPythonPlaygroundQuestionCorrectness({
    code: answer.value as string,
    output: result,
    verificationOutputRegexes: question.output_regexes_py || [],
    verificationInputRegexes: question.input_regexes_py || [],
    expectError: question.expect_error_py,
  });

  const isCorrect =
    verificationResult.failedOutputRegexes.length === 0 &&
    verificationResult.failedInputRegexes.length === 0;

  return updateQuestion({
    activity: state,
    question,
    answerPart: {
      ...answer,
      isAnswered: true,
      isCorrect,
      isRan: true,
      failedCorrectnessChecks: verificationResult.failedInputRegexes
        .map((regex) => `input code failed the regex check: ${regex}`)
        .concat(
          verificationResult.failedOutputRegexes.map(
            (regex) => `output result failed the regex check: ${regex}`
          )
        ),
    },
  });
}
